<template>
	<div id="app" class="">
		<router-view />
	</div>
</template>
<style></style>
<script lang="ts">
import { reactive, defineComponent } from "vue"

export default defineComponent({
	name: "App",
	setup() {},
})
</script>
